'use es6';

import getIn from 'transmute/getIn';
export const getCurrentGenericChannelId = getIn(['threadViewRootReducer', 'currentGenericChannelId']);